module.exports = __webpack_public_path__ + "media/assets/images/synchronize_manual_gray-8bafcef7f25bf88098bfa4451d871a1c.png";